import { constantTypes } from "../types";

const initState = {
  loading: 0,
  processingStatuses: [],
  processingStatusesObj: {},
  fileTypes: {},
};

export function constant(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case constantTypes.GET_PROCESSING_STATUSES_REQUEST: {
      return { ...state, loading: state.loading + 1 };
    }
    case constantTypes.GET_PROCESSING_STATUSES_SUCCESS: {
      return {
        ...state,
        loading: state.loading - 1,
        processingStatuses: payload,
        processingStatusesObj: payload.reduce(
          (acc, currentStatus) => ({
            ...acc,
            [currentStatus.code]: currentStatus.value,
          }),
          {}
        ),
      };
    }
    case constantTypes.GET_PROCESSING_STATUSES_FAILURE: {
      return { ...state, loading: state.loading - 1 };
    }

    case constantTypes.GET_PROCESSING_ERRORS_REQUEST: {
      return { ...state, loading: state.loading + 1 };
    }
    case constantTypes.GET_PROCESSING_ERRORS_SUCCESS: {
      return {
        ...state,
        loading: state.loading - 1,
        processingErrors: payload,
        processingErrorsObj: payload.reduce(
          (acc, currentError) => ({
            ...acc,
            [currentError.code]: currentError.value,
          }),
          {}
        ),
      };
    }
    case constantTypes.GET_PROCESSING_ERRORS_FAILURE: {
      return { ...state, loading: state.loading - 1 };
    }

    case constantTypes.GET_PRODUCT_FILE_TYPES_REQUEST: {
      return { ...state, loading: state.loading + 1 };
    }
    case constantTypes.GET_PRODUCT_FILE_TYPES_SUCCESS: {
      const productsFileTypesObj = Object.keys(payload).reduce(
        (acc, key) => ({
          ...acc,
          [key]: payload[key].reduce((acc, item) => {
            return { ...acc, [item.code]: item };
          }, {}),
        }),
        {}
      );

      return { ...state, loading: state.loading - 1, fileTypes: productsFileTypesObj };
    }
    case constantTypes.GET_PRODUCT_FILE_TYPES_FAILURE: {
      return { ...state, loading: state.loading - 1, fileTypes: {} };
    }

    default:
      return state;
  }
}
